import { render, staticRenderFns } from "./category-details-filter.vue?vue&type=template&id=0c50a1d3"
import script from "./category-details-filter.vue?vue&type=script&lang=js"
export * from "./category-details-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports